import { SubscriptionGift } from '../../types'
import { absoluteImageUrl } from '../utils/environment'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiSubscriptionGift = (strapiData: any): SubscriptionGift => {
    const { subscriptionPeriod, recipientName, status, purchaseDate, subscription_gift_card, recipientPhoneNumber, recipientMessage} = strapiData

    return {
        subscriptionPeriod,
        recipientName,
        status,
        purchaseDate,
        recipientPhoneNumber,
        recipientMessage,
        giftCardImageURL: absoluteImageUrl(subscription_gift_card.giftCard.url),
    }
}

export { fromStrapiSubscriptionGift }